import React, { useEffect } from "react";
import { connect } from "react-redux";
import { generateWorkingCapital } from "../../../../store/modules/financials/actions";
import FinancingHelper from "../../../../helpers/FinancingHelper";
import CurrencyFormatter from "currency-formatter";
import { primary } from "../../../../assets/colorPallet";

function WorkingCapital({
  currentCompanyWorkingCapital,
  dateOrder,
  dispatchGenerateWorkingCapital,
}) {
  // Mounted
  useEffect(() => {
    handleGenerateWorkingCapital();
  }, []);

  // Methods
  const handleGenerateWorkingCapital = async () => {
    await dispatchGenerateWorkingCapital({ dateOrder });
  };

  return (
    <div className="pb-10">
      <div className="flex items-center w-full mt-10">
        <div
          style={{ backgroundColor: primary }}
          className="absolute left-0 w-full h-12 bg-gradient-to-r from-transparent z-10 pointer-events-none"
        ></div>
        <div className="z-20" style={{ minWidth: "24em" }}></div>
        {currentCompanyWorkingCapital?.yearsFormatted?.map((date) => (
          <div
            className="z-20 w-40 font-semibold"
            style={{ minWidth: "10em" }}
          >
            <label className="text-white">{date}</label>
          </div>
        ))}
      </div>
      <div className="flex items-center pt-4">
        <div
          className="whitespace-nowrap flex items-center pt-4"
          style={{ minWidth: "24em" }}
        >
          <label className="font-semibold">
            Days Sales Outstanding (90-day)
          </label>
        </div>
        <div className="flex pt-4">
          {currentCompanyWorkingCapital?.yearlyDaysSalesOutstanding?.map(
            (item, index) => (
              <div
                className="flex items-center"
                style={{ minWidth: "10em" }}
              >
                <label
                  className={
                    item?.disabled
                      ? "disabled font-semibold"
                      : "font-semibold"
                  }
                >
                  {item?.value === Infinity ? "Infinity" : CurrencyFormatter.format(item?.value, { code: "" })}
                </label>
              </div>
            )
          )}
        </div>
      </div>

      <div className="flex items-center pt-4">
        <div
          className="whitespace-nowrap flex items-center border-t pt-4"
          style={{ minWidth: "24em" }}
        >
          <label className="font-semibold">
            Days Payable Outstanding (90-day)
          </label>
        </div>
        <div className="flex pt-4 border-t">
          {currentCompanyWorkingCapital?.yearlyDaysPayableOutstanding?.map(
            (item, index) => (
              <div
                className="flex items-center"
                style={{ minWidth: "10em" }}
              >
                <label
                  className={
                    item?.disabled
                      ? "disabled font-semibold"
                      : "font-semibold"
                  }
                >
                  {item?.value === Infinity ? "Infinity" : CurrencyFormatter.format(item?.value, { code: "" })}
                </label>
              </div>
            )
          )}
        </div>
      </div>

      <div className="flex items-center pt-4">
        <div
          className="whitespace-nowrap flex items-center border-t pt-4"
          style={{ minWidth: "24em" }}
        >
          <label className="font-semibold">
            Days Inventory on Hand (90-day)
          </label>
        </div>
        <div className="flex pt-4 border-t">
          {currentCompanyWorkingCapital?.yearlyDaysInventoryOnHand?.map(
            (item, index) => (
              <div
                className="flex items-center"
                style={{ minWidth: "10em" }}
              >
                <label
                  className={
                    item.disabled
                      ? "disabled font-semibold"
                      : "font-semibold"
                  }
                >
                  {item?.value === Infinity ? "Infinity" : CurrencyFormatter.format(item?.value, { code: "" })}
                </label>
              </div>
            )
          )}
        </div>
      </div>

      <div className="flex items-center pt-4">
        <div
          className="whitespace-nowrap flex items-center border-t pt-4"
          style={{ minWidth: "24em" }}
        >
          <label className="font-semibold">
            Other Current Assets % of Sales (90-day)
          </label>
        </div>
        <div className="flex pt-4 border-t">
          {currentCompanyWorkingCapital?.yearlyOtherCurrentAssetsPercentageOfSales?.map(
            (item, index) => (
              <div
                className="flex items-center"
                style={{ minWidth: "10em" }}
              >
                <label
                  className={
                    item.disabled
                      ? "disabled font-semibold"
                      : "font-semibold"
                  }
                >
                  {item?.value === Infinity ? "Infinity" : CurrencyFormatter.format(item?.value, { code: "" }) + "%"}
                </label>
              </div>
            )
          )}
        </div>
      </div>

      <div className="pt-4">
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center border-t pt-4"
            style={{ minWidth: "24em" }}
          >
            <label className="font-semibold">
              Other Current Liabilities % of Sales (90-day)
            </label>
          </div>
          <div className="flex pt-4 border-t">
            {currentCompanyWorkingCapital?.yearlyOtherLiabilitiesPercentageOfSales?.map(
              (item, index) => (
                <div
                  className="flex items-center"
                  style={{ minWidth: "10em" }}
                >
                  <label
                    className={
                      item.disabled
                        ? "disabled font-semibold"
                        : "font-semibold"
                    }
                  >
                    {item?.value === Infinity ? "Infinity" : CurrencyFormatter.format(item?.value, { code: "" }) + "%"}
                  </label>
                </div>
              )
            )}
          </div>
        </div>
      </div>

      <div className="pt-4">
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center border-t pt-4"
            style={{ minWidth: "24em" }}
          >
            <label className="font-semibold">
              Cash Working Capital Ratio
            </label>
          </div>
          <div className="flex pt-4 border-t">
            {currentCompanyWorkingCapital?.yearlyCashWorkingCapitalRatio?.map(
              (item) => (
                <div
                  className="flex items-center"
                  style={{ minWidth: "10em" }}
                >
                  <label className="font-semibold">
                    {item?.value === Infinity ? "Infinity" : CurrencyFormatter.format(item?.value, { code: "" }) + "x"}
                  </label>
                </div>
              )
            )}
          </div>
        </div>
      </div>

      <div className="pt-4">
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center border-t pt-4"
            style={{ minWidth: "24em" }}
          >
            <label className="font-semibold">
              Non-Cash Working Capital Ratio
            </label>
          </div>
          <div className="flex pt-4 border-t">
            {currentCompanyWorkingCapital?.yearlyNonCashWorkingCapitalRatio?.map(
              (item) => (
                <div
                  className="flex items-center"
                  style={{ minWidth: "10em" }}
                >
                  <label className="font-semibold">
                    {item?.value === Infinity ? "Infinity" : CurrencyFormatter.format(item?.value, { code: "" }) + "x"}
                  </label>
                </div>
              )
            )}
          </div>
        </div>
      </div>

      <div className="pt-4">
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center border-t pt-4"
            style={{ minWidth: "24em" }}
          >
            <label className="font-semibold">Inventory Turns (LTM)</label>
          </div>
          <div className="flex pt-4 border-t">
            {currentCompanyWorkingCapital?.yearlyInventoryTurns?.map(
              (item, index) => (
                <div
                  className="flex items-center"
                  style={{ minWidth: "10em" }}
                >
                  <label
                    className={
                      item.disabled
                        ? "disabled font-semibold"
                        : "font-semibold"
                    }
                  >
                    {item?.value === Infinity ? "Infinity" : CurrencyFormatter.format(item?.value, { code: "" }) + "x"}
                  </label>
                </div>
              )
            )}
          </div>
        </div>
      </div>

      <div className="pt-4">
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center border-t pt-4"
            style={{ minWidth: "24em" }}
          >
            <label className="font-semibold">
              Cash Conversion Cycle Days (90-day)
            </label>
          </div>
          <div className="flex pt-4 border-t">
            {currentCompanyWorkingCapital?.yearlyCashConversionCycleDays?.map(
              (item, index) => (
                <div
                  className="flex items-center"
                  style={{ minWidth: "10em" }}
                >
                  <label
                    className={
                      item.disabled
                        ? "disabled font-semibold"
                        : "font-semibold"
                    }
                  >
                    {item?.value === Infinity ? "Infinity" : CurrencyFormatter.format(item?.value, { code: "" })}
                  </label>
                </div>
              )
            )}
          </div>
        </div>
      </div>

      <div className="pt-4">
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center border-t pt-4"
            style={{ minWidth: "24em" }}
          >
            <label className="font-semibold">
              Cash Net Working Capital
            </label>
          </div>
          <div className="flex pt-4 border-t">
            {currentCompanyWorkingCapital?.yearlyCashNetWorkingCapital?.map(
              (item) => (
                <div
                  className="flex items-center"
                  style={{ minWidth: "10em" }}
                >
                  <label className="font-semibold">
                    {FinancingHelper.bracketFormatter(item?.value)}
                  </label>
                </div>
              )
            )}
          </div>
        </div>
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center pt-4"
            style={{ minWidth: "24em" }}
          >
            <label>12-Month Target</label>
          </div>
          <div className="flex pt-4">
            {currentCompanyWorkingCapital?.yearlyCashNetWorkingCapitalTwelveMonthsTarget?.map(
              (item, index) => (
                <div
                  className="flex items-center"
                  style={{ minWidth: "10em" }}
                >
                  <label className={item.disabled ? "disabled" : ""}>
                    {FinancingHelper.bracketFormatter(item?.value)}
                  </label>
                </div>
              )
            )}
          </div>
        </div>
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center pt-4"
            style={{ minWidth: "24em" }}
          >
            <label>6-Month Target</label>
          </div>
          <div className="flex pt-4">
            {currentCompanyWorkingCapital?.yearlyCashNetWorkingCapitalSixMonthsTarget?.map(
              (item, index) => (
                <div
                  className="flex items-center"
                  style={{ minWidth: "10em" }}
                >
                  <label className={item.disabled ? "disabled" : ""}>
                    {FinancingHelper.bracketFormatter(item?.value)}
                  </label>
                </div>
              )
            )}
          </div>
        </div>
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center pt-4"
            style={{ minWidth: "24em" }}
          >
            <label>3-Month Target</label>
          </div>
          <div className="flex pt-4">
            {currentCompanyWorkingCapital?.yearlyCashNetWorkingCapitalThreeMonthsTarget?.map(
              (item, index) => (
                <div
                  className="flex items-center"
                  style={{ minWidth: "10em" }}
                >
                  <label className={item.disabled ? "disabled" : ""}>
                    {FinancingHelper.bracketFormatter(item?.value)}
                  </label>
                </div>
              )
            )}
          </div>
        </div>
      </div>

      <div className="pt-4">
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center border-t pt-4"
            style={{ minWidth: "24em" }}
          >
            <label className="font-semibold">
              Non-Cash Net Working Capital
            </label>
          </div>
          <div className="flex pt-4 border-t">
            {currentCompanyWorkingCapital?.yearlyNonCashNetWorkingCapital?.map(
              (item) => (
                <div
                  className="flex items-center"
                  style={{ minWidth: "10em" }}
                >
                  <label className="font-semibold">
                    {FinancingHelper.bracketFormatter(item?.value)}
                  </label>
                </div>
              )
            )}
          </div>
        </div>
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center pt-4"
            style={{ minWidth: "24em" }}
          >
            <label>12-Month Target</label>
          </div>
          <div className="flex pt-4">
            {currentCompanyWorkingCapital?.yearlyNonCashNetWorkingCapitalTwelveMonthsTarget?.map(
              (item, index) => (
                <div
                  className="flex items-center"
                  style={{ minWidth: "10em" }}
                >
                  <label className={item.disabled ? "disabled" : ""}>
                    {FinancingHelper.bracketFormatter(item?.value)}
                  </label>
                </div>
              )
            )}
          </div>
        </div>
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center pt-4"
            style={{ minWidth: "24em" }}
          >
            <label>6-Month Target</label>
          </div>
          <div className="flex pt-4">
            {currentCompanyWorkingCapital?.yearlyNonCashNetWorkingCapitalSixMonthsTarget?.map(
              (item, index) => (
                <div
                  className="flex items-center"
                  style={{ minWidth: "10em" }}
                >
                  <label className={item.disabled ? "disabled" : ""}>
                    {FinancingHelper.bracketFormatter(item?.value)}
                  </label>
                </div>
              )
            )}
          </div>
        </div>
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center pt-4"
            style={{ minWidth: "24em" }}
          >
            <label>3-Month Target</label>
          </div>
          <div className="flex pt-4">
            {currentCompanyWorkingCapital?.yearlyNonCashNetWorkingCapitalThreeMonthsTarget?.map(
              (item, index) => (
                <div
                  className="flex items-center"
                  style={{ minWidth: "10em" }}
                >
                  <label className={item.disabled ? "disabled" : ""}>
                    {FinancingHelper.bracketFormatter(item?.value)}
                  </label>
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  currentCompanyWorkingCapital: state.financials.currentCompanyWorkingCapital,
});

const mapDispatchToProps = (dispatch) => ({
  async dispatchGenerateWorkingCapital({ dateOrder }) {
    await dispatch(generateWorkingCapital({ dateOrder }));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(WorkingCapital);
